<p-dialog header="{{header}}" [(visible)]="isShow">
  <div class="dialog-area" *ngIf="editedTongue">
    <!-- image -->
    <div *ngIf="originalImage">
      <img [src]="editedTongue.imageUrl" (click)="imageUploader.show()">
    </div>
    <div *ngIf="!originalImage">
      <ng-container *ngIf="imageUploader && imageUploader.image">
        <img [src]="imageUploader.displayDataUrl" (click)="imageUploader.show()">
      </ng-container>
      <ng-container *ngIf="imageUploader && !imageUploader.image">
        <button pButton label="Select Icon" (click)="imageUploader.show()" class="w-5rem"></button>
      </ng-container>
    </div>
    <div class="row">
      <div class="row-header">Name: </div>
      <div class="row-body">
        <input pInputText type="text" [(ngModel)]="editedTongue.name">
      </div>
    </div>
    <div class="row">
      <div class="row-header">Chinese Name: </div>
      <div class="row-body">
        <input pInputText type="text" [(ngModel)]="editedTongue.chineseName">
      </div>
    </div>
    <div class="row">
      <div class="row-header">Chinese Description: </div>
      <div class="row-body">
        <input pInputText type="text" [(ngModel)]="editedTongue.chineseDescription">
      </div>
    </div>
    <ng-container *ngFor="let diagnosis of editedTongue.diagnosisList">
      <div class="location-row" *ngIf="diagnosis.location !== 0">
        {{diagnosis.location | tongueLocation}}
      </div>
      <div class="row">
        <div class="row-header">TCM Pattern: </div>
        <div class="row-body">
          <input pInputText type="text" [(ngModel)]="diagnosis.pattern">
        </div>
      </div>
      <div class="row">
        <div class="row-header">Chinese TCM Pattern: </div>
        <div class="row-body">
          <input pInputText type="text" [(ngModel)]="diagnosis.chinesePattern">
        </div>
      </div>
      <div class="row">
        <div class="row-header">Symptoms of Male: </div>
        <div class="row-body">
          <textarea rows="4" pInputTextarea [(ngModel)]="diagnosis.symptomsMale"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="row-header">Chinese Symptoms of Male: </div>
        <div class="row-body">
          <textarea rows="4" pInputTextarea [(ngModel)]="diagnosis.chineseSymptomsMale"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="row-header">Symptoms of Female: </div>
        <div class="row-body">
          <textarea rows="4" pInputTextarea [(ngModel)]="diagnosis.symptomsFemale"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="row-header">Chinese Symptoms of Female: </div>
        <div class="row-body">
          <textarea rows="4" pInputTextarea [(ngModel)]="diagnosis.chineseSymptomsFemale"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="row-header">Recommendation: </div>
        <div class="row-body">
          <textarea rows="4" pInputTextarea [(ngModel)]="diagnosis.recommendation"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="row-header">Chinese Recommendation: </div>
        <div class="row-body">
          <textarea rows="4" pInputTextarea [(ngModel)]="diagnosis.chineseRecommendation"></textarea>
        </div>
      </div>
      <div class="row">
        <div class="row-header">Five Elements: </div>
        <div class="row-body">
          <div class="five-element-area">
            <div *ngFor="let fiveElement of AllFiveElements" [ngClass]="diagnosis.fiveElements.includes(fiveElement)? 'selected': ''" (click)="clickFiveElement(diagnosis, fiveElement)">
              {{fiveElement}}
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="row-header">Segment: </div>
        <div class="row-body">
          {{editedTongue.segment}}
        </div>
      </div>
    </ng-container>
    <div class="row">
      <p-selectButton [options]="statusOptions" [(ngModel)]="editedTongue.status"></p-selectButton>
    </div>
    <div class="row">
      <button pButton label="Save" (click)="onSave()"></button>
    </div>
  </div>
</p-dialog>

<tudi-image-file-selector (onUpload)="onImageUpload($event)"></tudi-image-file-selector>

